import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
import { Text } from '../../atoms';
const DateInput = ({ leadingLabel, ...props }) => {
    const theme = useTheme();
    return (_jsxs("label", { children: [leadingLabel && (_jsx(Text.Body, { as: "div", css: { fontSize: '1.12rem', marginBottom: '0.8rem' }, children: leadingLabel })), _jsx("input", { ...props, type: "date", css: {
                    outline: 'none',
                    border: 'none',
                    padding: '1.6rem',
                    borderRadius: '0.8rem',
                    backgroundColor: theme.color.foreground,
                    colorScheme: 'dark',
                } })] }));
};
export default DateInput;
//# sourceMappingURL=DateInput.js.map